import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'reactstrap'
import ScholarshipTemplate from 'components/templates/ScholarshipTemplate'
import { Container, Row, Col, SVGIcon, Image, BreadcrumbItem } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import Paper from 'components/atoms/Paper'
import scrollTo from 'utils/ui/scrollTo'
import triggerEvent from 'utils/dataLayer'

class Scholarship extends React.Component {
  constructor(props) {
    super(props)
    this.clickAuthLink = this.clickAuthLink.bind(this)
  }

  componentDidMount() {
    scrollTo('top')
  }

  clickAuthLink() {
    triggerEvent('ga/scholarship/bannerads/bigbanner')
  }

  render() {
    const { path } = this.props.match

    return (
      <ScholarshipTemplate path={path}>
        <div id="ScholarshipAbout">
          <div id="register-top-btn" className="section header-info">
            <Image
              src="/assets/img/scholarship/lp-banner-desktop.jpg"
              className="hidden-sm-down"
              onClick={this.clickAuthLink}
            />
            <Image
              src="/assets/img/scholarship/lp-banner-mobile.jpg"
              className="hidden-md-up"
              onClick={this.clickAuthLink}
            />
          </div>
          <div className="bg-white">
            <Container>
              <Breadcrumb>
                <BreadcrumbItem tag="a" href="/">
                  Quipper Campus
                </BreadcrumbItem>
                <BreadcrumbItem tag="b">
                  <b>Quipper Scholarship Challenge</b>
                </BreadcrumbItem>
              </Breadcrumb>
            </Container>
          </div>

          <div className="section bg-white">
            <Container>
              <Typography variant="title" component="h2">
                Tentang Quipper Scholarship Challenge
              </Typography>

              <Typography component="p">
                Quipper Scholarship Challenge (QSC) adalah kompetisi untuk memperebutkan beasiswa kuliah di universitas
                ternama di Indonesia.
              </Typography>

              <Typography component="p">
                Tahun ini Quipper bekerja sama dengan Kawasan Industri Jababeka memberikan beasiswa kuliah S1 di President
                University kepada siswa-siswi kelas XII SMA/SMK/MA di seluruh Indonesia yang terdaftar atau memiliki akun
                Quipper serta berhasil mendapat nilai terbaik pada serangkaian tes di platform Quipper.
              </Typography>

              <hr className="m-y-md" />

              <Image src="/assets/img/scholarship/pu-val-desktop.png" className="pu-val-desktop hidden-sm-down m-b-md" />
              <Image src="/assets/img/scholarship/pu-val-mobile.png" className="pu-val-mobile hidden-md-up m-b-md" />
            </Container>
          </div>

          <div className="section bg-campus about-campus">
            <Container>
              <Image className="hidden-sm-down" src="/assets/img/scholarship/pu-banner-desktop.png" />
              <Image className="hidden-md-up"src="/assets/img/scholarship/pu-banner-mobile.png" />

              <Typography variant="title" component="h2" className="m-b-md">
                Tentang President University
              </Typography>

              <Typography component="p">
                President University adalah salah satu perguruan tinggi swasta terbaik di Indonesia yang berkomitmen untuk memberikan pelayanan optimal dalam pengajaran, pembelajaran, dan penelitian.
              </Typography>

              <Typography component="p">
                President University terletak di Jababeka Industrial Park Cikarang, kawasan perindustrian terbesar di Asia Tenggara dan merupakan rumah bagi 1.700 perusahaan multinasional dari 30 negara, tentu mendukung tujuan pendidikan universitas untuk menyediakan “laboratorium hidup” dan pelatihan kerja tidak terbatas bagi mahasiswanya ..
                &nbsp;
                <b>
                  <a href="http://president.ac.id/" target="_blank" rel="noopener noreferrer">
                    selengkapnya
                  </a>
                </b>
              </Typography>
            </Container>
          </div>

          <div className="section bg-white majors">
            <Container>
              <Typography variant="title" component="h2">
                Pilihan Jurusan Beasiswa
              </Typography>

              <Row>
                <Col md="6">
                  <b><Image src="/assets/img/scholarship/bisnis.svg" />Bisnis</b>
                  <ul>
                    <li>Akuntansi</li>
                    <li>Bisnis & kewirausahaan</li>
                    <li>Manajemen</li>
                    <li>Bisnis Aktuaria</li>
                  </ul>

                  <b><Image src="/assets/img/scholarship/teknik.svg" />Teknik</b>
                  <ul>
                    <li>Teknik Sipil & Manajemen Konstruksi</li>
                    <li>Teknik Lingkungan & Manajemen Sumber Daya</li>
                    <li>Teknik Elektro, Energi & Sistem Kontrol</li>
                    <li>Teknik Mesin & Robotik</li>
                    <li>Teknik Industri & Logistik</li>
                  </ul>
                </Col>
                <Col md="6">
                  <b><Image src="/assets/img/scholarship/komputer.svg" />Ilmu Komputer</b>
                  <ul>
                    <li>Teknik Informatika</li>
                    <li>Bisnis & Sistem Informasi Manajemen</li>
                    <li>Desain Komunikasi Visual</li>
                  </ul>

                  <b><Image src="/assets/img/scholarship/kemanusiaan.svg" />Ilmu Kemanusiaan</b>
                  <ul>
                    <li>Hukum (Internasional, Korporasi, Teknologi)</li>
                    <li>Komunikasi Digital & Hubungan Masyarakat</li>
                    <li>Hubungan Internasional</li>
                    <li>Pendidikan Guru Sekolah Dasar (PGSD)</li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </div>

          <div id="step" className="section">
            <Container>
              <Typography variant="title" component="h2" className="m-b-lg">
                Proses Seleksi Quipper Scholarship Challenge
              </Typography>

              <hr className="desktop-step-indicator m-b-lg" />

              <Row>
                <Col md="4">
                  <Paper className="m-b-lg">
                    <div className="step-dot" />
                    <div className="m-b-md"><SVGIcon name="account" /></div>
                    <span>Tahap 1:</span>
                    <h5>Registrasi</h5>
                    <div className="m-y-md">10 Oktober- 9 Desember 2018</div>
                    <i>Mendaftar di <a href="https://docs.google.com/forms/d/10VtyM4OM5xSZbCIA11lPsafk_8CcR3qqZjoCFv2y0dg/edit">Sini</a> dan isi data diri kamu dengan lengkap</i>
                  </Paper>
                </Col>
                <Col md="4">
                  <Paper className="m-b-lg">
                    <div className="step-dot" />
                    <div className="m-b-md"><SVGIcon name="note" /></div>
                    <span>Tahap 2:</span>
                    <h5>Test Online</h5>
                    <div className="m-y-md">8 November - 12 Desember 2018</div>
                    <i>Tes seleksi online dan unggah foto rapor kelas 11 semester 1 & 2</i>
                  </Paper>
                </Col>
                <Col md="4">
                  <Paper>
                    <div className="step-dot" />
                    <div className="m-b-md"><SVGIcon name="announce" /></div>
                    <span>Tahap 3:</span>
                    <h5>Pengumuman</h5>
                    <div className="m-y-md">21 Desember 2018</div>
                    <i>Pengumuman dan penerimaan Letter of Acceptance (LoA)</i>
                  </Paper>
                </Col>
              </Row>

            </Container>
          </div>

          <div className="text-center m-a-lg p-a-lg">
            Baca FAQ & langkah-langkah mengikuti Quipper Scholarship Challenge,
            <Link className="bold" to="/scholarship/faq"> di sini</Link>
          </div>
        </div>
      </ScholarshipTemplate>
    )
  }
}

export default Scholarship
